import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Survey from './pages/Survey';
import ThankYou from './pages/ThankYou';
import AccesoEncuesta from './pages/AccesoEncuesta';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminReports from './pages/AdminReports';
import AdminEmployees from './pages/AdminEmployees';
import AdminNotifications from './pages/AdminNotifications';
import AdminSettings from './pages/AdminSettings';
import AdminTemplates from './pages/AdminTemplates';
import AdminSystem from './pages/AdminSystem';

const globalStyles = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    background: #f8f9fa;
    color: #333;
    line-height: 1.6;
  }
  a { text-decoration: none; color: inherit; }
  button { cursor: pointer; font-family: inherit; }
  input, select, textarea { font-family: inherit; }
`;

function App() {
  return (
    <>
      <style>{globalStyles}</style>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/acceso/:token" element={<AccesoEncuesta />} />
          <Route path="/encuesta/:token" element={<Survey />} />
          <Route path="/gracias" element={<ThankYou />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/informes" element={<AdminReports />} />
          <Route path="/admin/empleados" element={<AdminEmployees />} />
          <Route path="/admin/notificaciones" element={<AdminNotifications />} />
          <Route path="/admin/configuracion" element={<AdminSettings />} />
          <Route path="/admin/plantillas" element={<AdminTemplates />} />
          <Route path="/admin/sistema" element={<AdminSystem />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
